export default {"src":"/_next/static/media/icon_supreme_privacy.4f5b1a52.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};